var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 329.249 329.249",
    style: {
      enableBackground: "new 0 0 329.249 329.249"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_62_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1121_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1122_",
    style: {
      fill: "#F3D8B6"
    },
    d: "M247.814,233.696c-18.667-6.681-51.458-11.736-51.458-81.376h-29.23h-5.002 h-29.23c0,69.64-32.791,74.695-51.458,81.376c0,47.368,68.832,48.824,80.688,53.239v1.537c0,0,0.922-0.188,2.501-0.68 c1.579,0.492,2.501,0.68,2.501,0.68v-1.537C178.981,282.521,247.814,281.064,247.814,233.696z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1123_",
    style: {
      fill: "#EEC8A2"
    },
    d: "M196.356,152.321h-29.23h-2.501v135.472c1.579,0.492,2.501,0.68,2.501,0.68 v-1.537c11.856-4.414,80.688-5.871,80.688-53.238C229.147,227.015,196.356,221.961,196.356,152.321z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_58_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1124_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1125_",
    style: {
      fill: "#F3DBC4"
    },
    d: "M164.627,174.483c-27.454,0-48.409-23.119-57.799-40.456 S90.94,54.582,111.168,27.13c19.808-26.883,53.459-13.838,53.459-13.838s33.649-13.045,53.458,13.838 c20.226,27.452,13.726,89.56,4.335,106.897C213.028,151.364,192.075,174.483,164.627,174.483z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1126_",
    style: {
      fill: "#EDCEAE"
    },
    d: "M218.085,27.13c-19.81-26.883-53.458-13.838-53.458-13.838h-0.002v161.192 c0.001,0,0.001,0,0.002,0c27.449,0,48.401-23.119,57.794-40.456C231.811,116.69,238.311,54.583,218.085,27.13z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_55_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_57_",
    transform: "matrix(0.3543 -0.9351 0.9351 0.3543 46.5967 281.0264)",
    style: {
      fill: "#EDCEAE"
    },
    cx: 226.798,
    cy: 106.771,
    rx: 17.187,
    ry: 10.048
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_56_",
    transform: "matrix(0.3543 0.9351 -0.9351 0.3543 166.0001 -26.8553)",
    style: {
      fill: "#F3DBC4"
    },
    cx: 102.447,
    cy: 106.778,
    rx: 17.187,
    ry: 10.048
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_51_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1127_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1128_",
    style: {
      fill: "#B7CAE9"
    },
    d: "M284.607,288.568v40.681H44.643v-40.681c0-30.431,17.377-56.963,40.605-70.913 c6.043-3.641,19.69-7.43,26.844-9.196c5.953-1.488,53.438,22.729,53.438,22.729s48.674-23.218,54.627-21.729 c7.154,1.766,17.802,4.554,23.844,8.196C267.23,231.605,284.607,258.137,284.607,288.568z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1129_",
    style: {
      fill: "#96B3D4"
    },
    d: "M244.002,217.655c-6.043-3.641-16.69-6.429-23.844-8.196 c-5.953-1.488-54.627,21.729-54.627,21.729s-0.321-0.164-0.906-0.459v98.52h119.982v-40.681 C284.607,258.137,267.229,231.605,244.002,217.655z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_48_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1130_",
    style: {
      fill: "#494857"
    },
    points: "186.292,235.806 164.625,228.973 142.958,235.806 157.272,246.798  148.292,329.249 180.958,329.249 171.978,246.798  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1131_",
    style: {
      fill: "#33333F"
    },
    points: "186.292,235.806 164.625,228.973 164.625,329.249 180.958,329.249  171.978,246.799  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_45_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1132_",
    style: {
      fill: "#DEDDE0"
    },
    d: "M212.792,204.681l-48.167,23.441l-48.167-23.441 c-11.5,5.5,10.396,38.436,14.833,36.833c10.963-3.96,33.334-10.329,33.334-10.329s22.371,6.369,33.334,10.329 C202.396,243.118,224.292,210.181,212.792,204.681z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1133_",
    style: {
      fill: "#DEDDE0"
    },
    d: "M212.792,204.681l-48.167,23.441v3.063c0,0,22.371,6.369,33.334,10.329 C202.396,243.118,224.292,210.181,212.792,204.681z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_41_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1134_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1135_",
    style: {
      fill: "#A7B8D4"
    },
    d: "M206.619,97.84H178.93c-1.185,0-2.356,0.243-3.431,0.713l-10.874,3.873 l-10.874-3.873c-1.075-0.47-2.246-0.713-3.431-0.713h-27.688c-5.509,0-7.411,9.474-7.411,9.474 c0,12.532,9.191,22.692,23.756,22.692c8.882,0,17.409-9.44,22.649-17.081h6c5.24,7.641,13.768,17.081,22.649,17.081 c14.565,0,23.756-10.16,23.756-22.692C214.03,107.314,212.128,97.84,206.619,97.84z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1136_",
    style: {
      fill: "#8AA4C2"
    },
    d: "M206.619,97.84H178.93c-1.185,0-2.356,0.243-3.431,0.713l-10.874,3.873v10.5h3 c5.24,7.641,13.768,17.081,22.649,17.081c14.565,0,23.756-10.16,23.756-22.692C214.03,107.314,212.128,97.84,206.619,97.84z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_34_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1139_",
    style: {
      fill: "#545465"
    },
    d: "M221.773,22.976c-2.16,0.019-25.469-13.121-41.382-16.355 c-18.766-3.814-18.777-0.529-26.02,1.516c-29.41-9.014-52.972-15.012-51.927,7.003c1.759,37.07-9.345,65.989-4.863,78.938 s8.466,23.407,8.466,23.407s0.996,3.565,2.988-16.854s-4.579-42.372,11.137-40.379c15.716,1.992,10.785,14.805,44.436,14.805 c33.391,0,28.719-12.813,44.436-14.805c15.716-1.992,9.145,19.96,11.137,40.379s2.988,16.854,2.988,16.854 s3.984-10.458,8.466-23.407C236.119,81.129,241.125,22.806,221.773,22.976z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1142_",
    style: {
      fill: "#494857"
    },
    d: "M221.773,22.976c-2.16,0.019-25.469-13.121-41.382-16.355 c-7.986-1.624-12.57-1.958-15.766-1.653v70.088c33.372-0.004,28.706-12.813,44.419-14.804c15.716-1.992,9.145,19.96,11.137,40.379 s2.988,16.854,2.988,16.854s3.984-10.459,8.466-23.407C236.119,81.129,241.125,22.807,221.773,22.976z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_8_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_33_",
    transform: "matrix(0.3543 0.9351 -0.9351 0.3543 166.0001 -26.8553)",
    style: {
      fill: "#F3DBC4"
    },
    cx: 102.447,
    cy: 106.778,
    rx: 17.187,
    ry: 10.048
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_32_",
    transform: "matrix(0.3543 -0.9351 0.9351 0.3543 46.5967 281.0264)",
    style: {
      fill: "#EDCEAE"
    },
    cx: 226.798,
    cy: 106.771,
    rx: 17.187,
    ry: 10.048
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.89adeff89f393106cb2e602c6a4a46ff.svg";
export { ForwardRef as ReactComponent };